<template>
  <div class="welcome-page">
    <section class="welcome-container">
      <navbar />
      <div class="submit-btn">
        <a v-smooth-scroll class="link" href="#coreExtra">
          {{ $t('welcomePage.welcome.registration') }}
        </a>
      </div>

      <div class="more-btn">
        <a v-smooth-scroll href="#main">Μάθε Περισσότερα</a>
      </div>
    </section>

    <main id="main">
      <section class="flex-welcome">
        <div class="row-section">
          <div class="text">
            {{ $t('welcomePage.welcome.entities.whyToUs.body[0]') }}
            <br /><br />
            {{ $t('welcomePage.welcome.entities.whyToUs.body[1]') }}
          </div>
          <div class="section-entity">
            <div class="circle">
              <span>{{
                $t('welcomePage.welcome.entities.whyToUs.title')
              }}</span>
            </div>
          </div>
          <div class="img"></div>
        </div>
        <div class="row-section reversed">
          <div class="text">
            {{ $t('welcomePage.welcome.entities.target.body[0]') }}
            <br /><br />
            {{ $t('welcomePage.welcome.entities.target.body[1]') }}
          </div>
          <div class="section-entity">
            <div class="circle">
              <span>{{ $t('welcomePage.welcome.entities.target.title') }}</span>
            </div>
          </div>
          <div class="img target-img"></div>
        </div>
      </section>

      <section id="coreExtra" class="flex-welcome">
        <div class="section-head">
          <div class="title"><span>SLM Core - SLM Extra</span></div>
          <b-img src="@/assets/images/traffic_light.svg" fluid></b-img>
        </div>

        <b-card class="mt-2 border-0">
          <b-media>
            <b-card class="border-0 ml-4">
              <b-media>
                Επίλεξε με ποιον από τους παρακάτω τρόπους θα ήθελες να
                συνεργαστείς μαζί μας
              </b-media>
            </b-card>

            <b-container>
              <b-row align-v="stretch">
                <b-col sm="12" lg="6" xl="4">
                  <div class="card-slm">
                    <b-container class="title mt-4" fluid>
                      <span>SLM Core</span>
                    </b-container>
                    <b-list-group class="list p-2">
                      <b-list-group-item v-for="(item, i) in slmCore" :key="i">
                        <b-icon icon="signpost-split"></b-icon>
                        <span>{{ item }}</span>
                      </b-list-group-item>
                    </b-list-group>
                    <div id="btnCore" class="slm-btn m-2 mb-4">
                      <b-button
                        class="core-btn"
                        @click.prevent="didClickApply('core', 'drivers')"
                      >
                        Μπες στο SLM Core
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <b-col sm="12" lg="6" xl="4">
                  <div class="card-slm">
                    <b-container class="title mt-4" fluid>
                      <span>SLM Extra</span>
                    </b-container>
                    <b-list-group class="list p-2">
                      <b-list-group-item v-for="(item, i) in slmExtra" :key="i">
                        <b-icon icon="signpost-split"></b-icon>
                        <span>{{ item }}</span>
                      </b-list-group-item>
                    </b-list-group>
                    <div id="btnExtra" class="slm-btn m-2 mb-4">
                      <b-button
                        class="extra-btn"
                        @click.prevent="didClickApply('extra', 'drivers')"
                      >
                        Μπες στο SLM Extra
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <b-col sm="12" lg="6" xl="4">
                  <div class="card-slm">
                    <b-container class="title mt-4" fluid>
                      <span>Warehouse Core</span>
                    </b-container>
                    <b-list-group class="list p-2">
                      <b-list-group-item
                        v-for="(item, i) in warehouseCore"
                        :key="i"
                      >
                        <b-icon icon="signpost-split"></b-icon>
                        <span>{{ item }}</span>
                      </b-list-group-item>
                    </b-list-group>
                    <div id="btnWarehouse" class="slm-btn m-2 mb-4">
                      <b-button
                        class="warehouse-btn"
                        @click.prevent="didClickApply('core', 'warehouse')"
                      >
                        Μπες στο Warehouse Core
                      </b-button>
                    </div>
                  </div>
                </b-col>

                <b-col sm="12" lg="6" xl="4">
                  <div class="card-slm">
                    <b-container class="title mt-4" fluid>
                      <span>Warehouse Extra</span>
                    </b-container>
                    <b-list-group class="list p-2">
                      <b-list-group-item
                        v-for="(item, i) in warehouseExtra"
                        :key="i"
                      >
                        <b-icon icon="signpost-split"></b-icon>
                        <span>{{ item }}</span>
                      </b-list-group-item>
                    </b-list-group>
                    <div id="btnWarehouse" class="slm-btn m-2 mb-4">
                      <b-button
                        class="warehouse-btn"
                        @click.prevent="didClickApply('extra', 'warehouse')"
                      >
                        Μπες στο Warehouse Extra
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </b-media>
        </b-card>
      </section>
    </main>
    <a
      v-show="shouldShowApplyFab"
      ref="aplyFab"
      v-smooth-scroll
      class="apply-fab"
      href="#coreExtra"
    >
      {{ $t('welcomePage.welcome.registration') }}
    </a>

    <page-footer />
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/analytics';

import {
  SLM_CORE,
  SLM_EXTRA,
  WAREHOUSE_CORE,
  WAREHOUSE_EXTRA
} from '@/store/constants';

import Navbar from '../components/Navbar.vue';
import PageFooter from '../components/PageFooter.vue';

export default {
  name: 'Welcome',
  components: {
    Navbar,
    PageFooter
  },
  data() {
    return {
      slmCore: SLM_CORE,
      slmExtra: SLM_EXTRA,
      warehouseCore: WAREHOUSE_CORE,
      warehouseExtra: WAREHOUSE_EXTRA,
      shouldShowApplyFab: false
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const coreExtra = document.getElementById('coreExtra');
      const btnCore = document.getElementById('btnCore');

      const coreExtraHeightFromTop = coreExtra.offsetTop + btnCore.offsetTop;
      const currentTopView = window.scrollY;
      const screenHeight = window.innerHeight;
      const ALLOW_GAP = 0.2; // 20/100 extra allowing gap

      // want to display the button only between top "Submit" button and id="btnCore"
      const isShowingTopButton =
        currentTopView * (1 + ALLOW_GAP) < screenHeight;
      const isShowingCoreExtraContainer =
        currentTopView + screenHeight * (1 - ALLOW_GAP) >
        coreExtraHeightFromTop;

      this.shouldShowApplyFab =
        !isShowingTopButton && !isShowingCoreExtraContainer;

      if (this.shouldShowApplyFab) {
        this.$refs.aplyFab.style.marginRight = '80px';
      }
    },
    async didClickApply(employmentType, department) {
      // if (slmType === 'core') {
      //   const isModalConfirmOpen = await this.alertFullCoreTeam();

      //   if (isModalConfirmOpen) {
      //     requestSlmType = 'extra';
      //   } else {
      //     return;
      //   }
      // }

      this.$store.commit('setSelectedSlmType', employmentType);
      this.$store.commit('setSelectedDepartment', department);

      window.scrollTo({ top: 0 });

      window.fbq('trackCustom', 'ApplyClicked');
      firebase.analytics().logEvent('apply_clicked');

      this.$router.push('/login');
    },
    alertFullCoreTeam() {
      return this.$bvModal.msgBoxConfirm(
        this.$i18n.t('welcomePage.welcome.alertCoreMessage.message'),
        {
          title: this.$i18n.t('welcomePage.welcome.alertCoreMessage.title'),
          okTitle: this.$i18n.t('generic.yes'),
          cancelTitle: this.$i18n.t('generic.no'),
          okVariant: 'alert'
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/media_screen.scss';
@import '../assets/styles/welcome.scss';

$white: #fff;
$orange: #f68b24;
$orange3: #f4731f;
$orange9: rgba(246, 139, 36, 0.9);
$orange6: rgba(246, 139, 36, 0.6);
$black: #363636;

.welcome-page {
  display: flex;
  flex-direction: column;
}
body,
footer {
  background-color: #fff;
}
main {
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  padding: 24px 0;
}

.apply-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  padding: 24px;
  background-color: $white;
  border-radius: 6px;
  border: 2px solid;
  border-color: $orange3;
  background: $white;
  z-index: 1000;
  text-decoration: unset;
  font-weight: bold;
  color: $orange3;

  &:hover {
    color: $black;
    border-color: $black;
  }
}

.welcome-benefits,
.flex-welcome {
  align-items: center;
  width: 100%;
  margin: 20px 0;
  padding: 0 40px;
}

.flex-welcome {
  .row-section {
    display: grid;
    grid-template-columns: 50% 0 50%;
    margin-bottom: 3rem;
    height: 400px;

    .section-entity {
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      height: 100%;
      width: 8rem;
      margin-left: -4rem;

      .circle {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid $black;
        border-radius: 50%;
        background: $orange;
        width: 8rem;
        height: 8rem;

        span {
          color: $white;
          font-weight: bold;
          text-align: center;
        }
      }
    }
    .img,
    .text {
      width: 100%;
    }
    .text {
      padding-right: 7rem;
      display: inline-flex;
      align-items: center;
    }
    .img {
      background: url('../assets/images/slmAdds1.png') no-repeat 100% / cover;
    }
    .target-img {
      background: url('../assets/images/courier_berta.svg') no-repeat 100% /
        cover;
    }
  }
}

.section-head {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    position: absolute;
    bottom: 50%;
    padding: 4px;

    span {
      font-size: 1.6em;
    }
  }
}

.border-0 {
  border: none;
}

.card-slm {
  box-shadow: 0px 4px 12px 1px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .title {
    text-align: center;
    background: $orange9;
    padding: 0.75rem 0;

    span {
      font-size: 1.3em;
      font-weight: 500;
      color: $white;
    }
  }
  .list {
    .list-group-item {
      border: none;
      padding: 0.25rem 1rem;

      span {
        margin-left: 0.8rem;
      }
    }
  }
}

@media screen and (max-width: 733px) {
  .flex-welcome {
    padding: 0 20px;

    .row-section {
      grid-template-columns: unset;
      grid-template-rows: 48px auto 300px;
      grid-gap: 1rem;
      height: unset;

      .text {
        text-align: center;
        padding: 0 2rem;
      }

      .section-entity {
        width: 100%;
        margin: 0;
        grid-row-start: 1;

        .circle {
          width: 100%;
          height: 3rem;
          border-radius: 0;
          border: unset;
        }
      }
    }
  }

  .section-head {
    .title {
      span {
        font-size: 1.2em;
      }
    }
  }

  .card-container {
    flex-wrap: wrap;
    .card-slm {
      min-width: 100%;
    }
  }
}

@media screen and (min-width: 734px) {
  .reversed {
    .img {
      grid-column-start: 1;
      grid-row-start: 1;
    }
    .section-entity {
      grid-column-start: 2;
      grid-row-start: 1;
    }
    .text {
      grid-column-start: 3;
      text-align: end;
      padding-right: 0 !important;
      padding-left: 7rem;
    }
  }
}
</style>
